import { useEffect, useState } from "react";
import { SiteAssignmentSiteAssocEntity } from "../model/site-assignment-assoc";
import {SiteAssignment, SiteAssignmentEntity} from "../model/site-assignment";
import {transportType, TransportType} from "../model/transport";
import {firstOrUndefined} from "../util/util";
import {TransportCategory} from "../model/transport-category";
import {
  useLazyGetDeliverySiteSiteAssignmentBySiteQuery,
  useLazyGetPickupSiteSiteAssignmentBySiteQuery
} from "../store/entity/site-assignment/site-assignment-store";

const sort = (a: SiteAssignmentSiteAssocEntity, b: SiteAssignmentSiteAssocEntity, service: boolean): number => {
  if (service) {
    return a.servicePreferenceRank - b.servicePreferenceRank;
  } else {
    return a.normalPreferenceRank - b.normalPreferenceRank;
  }
};

const getPreferredSiteId = (payload: SiteAssignment | undefined, service: boolean): string | undefined => {
  const assignment = payload ? SiteAssignmentEntity.from(payload) : undefined;
  const sortedAssocs = assignment?.siteAssocs?.sort((a, b) => {
    return sort(a, b, service);
  });
  return firstOrUndefined(sortedAssocs)?.siteId;
};

export type UseGetPreferredSiteProps = {
  serviceWork?: boolean;
  siteId?: string;
  regionId?: string;
  type: TransportType
  category?: TransportCategory
}

export type UseGetPreferredSiteResult = {
  siteId?: string
}

export const useGetPreferredSite = (props: UseGetPreferredSiteProps): UseGetPreferredSiteResult => {
  const { serviceWork = false, siteId, regionId, category, type } = props;

  const [_siteId, _setSiteId] = useState<string | undefined>(undefined);

  const [pickupTrigger] = useLazyGetPickupSiteSiteAssignmentBySiteQuery();
  const [deliveryTrigger] = useLazyGetDeliverySiteSiteAssignmentBySiteQuery();

  useEffect(() => {
    if (regionId && siteId && category) {
      const trigger = type === transportType.pickup ? pickupTrigger : deliveryTrigger;
      trigger({ regionId: regionId, siteId: siteId, category: category.code })
        .unwrap()
        .then((payload) => {
          const siteId = getPreferredSiteId(payload, serviceWork);
          _setSiteId(siteId);
        });
    } else {
      _setSiteId(undefined)
    }
  }, [pickupTrigger, deliveryTrigger, siteId, regionId, category, serviceWork, type]);

  return {
    siteId: _siteId
  };
};
